export const skeletonTokens = {
  skeleton: {
    root: {
      borderRadius: '{borderRadius.sm}'
    },
    colorScheme: {
      light: {
        root: {
          background: '{surface.300}'
        },
        animation: {
          background: '{surface.100}'
        }
      }
    }
  }
};

export type SkeletonTokens = typeof skeletonTokens;
